import { createContext, useContext } from 'solid-js';

/*
	Nested <a> elements are invalid HTML. The parser un-nests them, splitting the outer anchor into
	several clones that all carry its data-hk, so hydration then walks a DOM that doesn't match the
	markup the server emitted and the section dies. Widgets that emit an anchor consult this and
	render a plain wrapper instead when they already sit inside one: the outer link takes the click.
*/
export const InsideLinkContext = createContext<() => boolean>(() => false);

export function useInsideLink(): (() => boolean)
{
	return useContext(InsideLinkContext);
}
